import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-permission-error',
  templateUrl: './permission-error.component.html',
  styleUrls: ['./permission-error.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class PermissionErrorComponent implements OnInit {
  private router = inject(Router);

  ngOnInit(): void {}

  toHome() {
    this.router.navigate(['/home']);
  }
}
